import { render, staticRenderFns } from "./RunList.vue?vue&type=template&id=a2d1beba&"
import script from "./RunList.vue?vue&type=script&lang=js&"
export * from "./RunList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports